import { createContext, useContext, useState, useCallback, useMemo } from "react";
import { UI, LANGUAGES } from "@/i18n/translations";

const STORAGE_KEY = "allolabs_lang";
const LanguageContext = createContext(null);

const getInitial = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && UI[saved]) return saved;
  } catch (e) {
    /* ignore */
  }
  return "en";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(getInitial);

  const setLang = useCallback((code) => {
    if (!UI[code]) return;
    setLangState(code);
    try {
      localStorage.setItem(STORAGE_KEY, code);
      document.documentElement.setAttribute("lang", code);
    } catch (e) {
      /* ignore */
    }
  }, []);

  const value = useMemo(() => ({ lang, setLang, t: UI[lang], languages: LANGUAGES }), [lang, setLang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
